import * as $runtime from "../runtime.js";
import * as Control$dMonad$dReplace from "../Control.Monad.Replace/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const sequence_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableArray)(Data$dFoldable.identity);
const Host = x => x;
const runHost = v => () => {
  const actionsMutable = Specular$dInternal$dEffect.emptyDelayed();
  const result = Specular$dInternal$dRIO.runRIO(actionsMutable)(v)();
  const actions = Specular$dInternal$dEffect.unsafeFreezeDelayed(actionsMutable)();
  return Data$dTuple.$Tuple(result, Specular$dInternal$dEffect.sequenceEffects(actions));
};
const monadHost = Specular$dInternal$dRIO.monadRIO;
const monadEffectHost = Specular$dInternal$dRIO.monadEffectRIO;
const monadCleanupHost = {onCleanup: action => actions => Specular$dInternal$dEffect.pushDelayed(actions)(action)(), Monad0: () => Specular$dInternal$dRIO.monadRIO};
const liftHost = dictMonadCleanup => {
  const Monad0 = dictMonadCleanup.Monad0();
  const Bind1 = Monad0.Bind1();
  const pure2 = Monad0.Applicative0().pure;
  return dictMonadEffect => m => Bind1.bind(dictMonadEffect.liftEffect(runHost(m)))(v => {
    const $0 = v._1;
    return Bind1.bind(dictMonadCleanup.onCleanup(v._2))(() => pure2($0));
  });
};
const functorHost = Specular$dInternal$dRIO.functorRIO;
const bindHost = Specular$dInternal$dRIO.bindRIO;
const applyHost = Specular$dInternal$dRIO.applyRIO;
const applicativeHost = Specular$dInternal$dRIO.applicativeRIO;
const monadReplaceHost$lazy = /* #__PURE__ */ $runtime.binding(() => (
  {
    newSlot: Specular$dInternal$dRIO.bindImpl(() => ({value: []}))(cleanupsRef => {
      const destroy = () => {
        const cleanups = cleanupsRef.value;
        cleanupsRef.value = [];
        return sequence_(cleanups)();
      };
      const append$p = m => {
        const $0 = runHost(m);
        return () => {
          const v = $0();
          const $1 = cleanupsRef.value;
          cleanupsRef.value = Data$dSemigroup.concatArray($1)([v._2]);
          return v._1;
        };
      };
      return Specular$dInternal$dRIO.bindImpl(monadCleanupHost.onCleanup(destroy))(() => Specular$dInternal$dRIO.pureImpl(Control$dMonad$dReplace.$Slot(
        m => () => {
          destroy();
          return append$p(m)();
        },
        destroy,
        append$p(monadReplaceHost$lazy().newSlot)
      )));
    }),
    Monad0: () => Specular$dInternal$dRIO.monadRIO,
    MonadCleanup1: () => monadCleanupHost
  }
));
const monadReplaceHost = /* #__PURE__ */ monadReplaceHost$lazy();
export {Host, applicativeHost, applyHost, bindHost, functorHost, liftHost, monadCleanupHost, monadEffectHost, monadHost, monadReplaceHost, runHost, sequence_};
